export const LANGUAGES = {
  'en-US': 'English',
  'en-GB': 'English',
  'en-EU': 'English',
  'fr-FR': 'Français',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'it-IT': 'Italiano',
};
